import Esepration from "../pages/eSepration/Esepration";
import ShortNotice from "../pages/eSepration/shortNotice";
import OfficeOrders from "../pages/postPromotion/officeOrders";
import PostPromotion from "../pages/postPromotion/PostPromotion";
import ProbationConfirmation from "../pages/postPromotion/probationConfirmation";

export const all_routes = {
  privacyPolicy: "/privacy-policy",
  officeLocationMap: "/map-office",
  userManual: "/user-manual",
  publicUserManual: "/user-manual",
  introVideo: "/intro-video",
  publicIntroVideo: "/intro-video",
  vpf: {
    list: "vpf/list",
  },

  auditLogs: "/audit-logs",
  adminActivityLogs: "/admin-activity-logs",
  adminDashboard: "/dashboard",
  users: "/users",
  adminUsers: "/users/admin",
  otpLogs: "/otp/logs",
  nocSapLogs: "/noc/sap/logs",
  hrmsApiLogs: "/hrms/api/logs",

  adminLogin: `/admin/login/${(process.env.REACT_APP_RANDOM || "").replace(/['"\s]/g, "") || "admin"}`,
  adminForgotPassword: "/admin/forgot-password",
  adminTwoStepVerification: "/admin/two-step-verification",
  adminSuccess: "/admin/success",
  adminEmailVerification: "/admin/email-verification",
  adminResetPassword: "/admin/reset-password",
  adminVerifyOtp: "/admin/verify-otp",
  adminChangePassword: "/admin/change-password",
  adminProfile: "/admin-profile",
  adminMyProfile: "/admin-profile",
  adminResetPasswordSuccess: "/admin/success",
  adminWorkSchedule: "/admin/work-schedule",

  login: "/login",
  register: "/register",
  forgotPassword: "/forgot-password",
  twoStepVerification: "/two-step-verification",
  success: "/success",
  emailVerification: "/email-verification",
  resetPassword: "/reset-password",
  verifyOtp: "/verify-otp",
  changePassword: "/change-password",
  resetPasswordSuccess: "/success",
  lockScreen: "/lock-screen",

  officeLocation: {
    list: "/office-location",
    add: "/office-location/add",
    edit: "/office-location/edit/:id",
  },

  masterBeacon: {
    list: "/master-beacon/list",
    add: "/master-beacon/add",
    edit: "/master-beacon/edit/:id",
    delete: "/master-beacon/delete/:id",
    details: "/master-beacon/details/:id",
  },

  // Employees
  employeeDashboard: "/employee-dashboard",
  myprofile: "/my-profile",
  attendance: {
    list: "/employee-attendance",
  },

  leave: {
    list: "/employee-leave",
    details: "/employee-leave/details/:id",
    create: "/employee-leave/create",
  },
  // Reimbursement
  reimbursementItDeclaration: "/reimbursement-it-declaration",
  itDeclaration: {
    list: "/it-declaration",
    create: "/it-declaration/create",
    details: "/it-declaration/details/:id",
  },
  Reimbursement: {
    list: "reimbursement-list",
    details: "reimbursement/details/:id",
    create: "reimbursement/create",
    edit: "reimbursement/edit/:id",
    sync: "/services/reimbursement/sync",
  },
  reimbursementAdmin: "/services/reimbursement",
  reimbursementSync: "/services/reimbursement/sync",
  eOffice: "/services/e-office",

  location: {
    list: "employee-location",
  },
  employees: {
    list: "/employees",
    verifications: "/employees/verifications",
    officeLocation: "/employees/office-location",
    profile: "/employees/profile/:id",
    profile_reasons: "/employees/profile-reasons",
  },
  notification: "notification",
  rolesPermissions: "/user-management/roles-permissions",
  findAllDepartment: "/departments",
  findAllDesignation: "/designations",
  myProfile: "/my-profile",
  workShift: "/work-shift",
  employeeWorkShift: "/employee/work-shift",
  workShiftVerification: "/work-shift/verifications",
  holidaysCalendar: "/holidays-calendar",
  faceData: "/face-data-regularize",
  employeeFaceData: "/employee-face-data-regularize",
  employeeAttendenceRegularize: "/attendence-regularize",
  employeeDailyAttendence: "/daily-attendence",
  toDoList: "/to-do-list",
  reportingEmployees: "/reprting-employees",
  reportingEmployeesDailyAttendence: "/reprting-employees/daily-attendence",
  teamShiftOverview: "/attendance/summary",
  reportingEmployeeAttendance: "/reporting-employees/attendance",
  reportingEmployeeShift: "/reporting-employees/shift",
  attendanceSummary: "/attendance-summary",
  language: {
    list: "/language",
    updateString: "/language-phrases",
    versionsTest: "/language-versions-test",
  },
  chatbot: {
    list: "/chatbot",
    chat: "/chatbot/chat",
  },
  announcements: {
    list: "/announcements",
  },
  eAttestation: {
    master: "/e-attestation/master",
    approver: "/e-attestation/approver",
    list: "/services/e-attestation",
    create: "/services/e-attestation/create",
    edit: "/services/e-attestation/edit/:id",
    details: "/services/e-attestation/details/:id",
  },
  circulars: {
    list: "/circulars",
    main: "/circulars",
  },
  employeeSetting: "/settings",
  settings: {
    configVars: "/setting-config-vars",
    general: "/setting-general",
    modules: "/setting-modules",
    sms: "/setting-sms",
    email: "/setting-email",
    notification: "/setting-notification",
    language: "/setting-language",
    app: "/setting-app",
    global: "/setting-global",
    pusher: "/setting-pusher",
    recaptcha: "/setting-recaptcha",
    storage: "/setting-storage",
    cache: "/setting-cache",
    esepHrWing: "/setting-esep-hr-wing",
    esepHrLevelConfig: "/setting-esep-hr-level-config",
    staffQuarterApproval: "/setting-staff-quarter-approval",
    staffQuarterChangeApprover: "/setting-staff-quarter-change-approver",
    errorList: "/setting-errorList",
    leave: {
      leaveType: "/setting-leave/leave-type",
    },
  },

  logs: {
    loginLogs: "/logs/login-logs",
  },

  templates: {
    smsTemplates: "/templates/sms-templates",
    emailTemplates: "/templates/email-templates",
  },
  employeeWorkSchedule: "/employee-work-schedule",

  // Universal Worklist / To-Do Work List
  universalWorklist: "/universal-worklist",
  todoWorklist: {
    main: "/todo-worklist",
    tasks: "/todo-worklist/tasks",
    tasksMobile: "/todo-worklist/tasks-mobile",
    taskDetails: "/todo-worklist/task-details/:id",
    nocTaskDetails: "/todo-worklist/noc-task-details/:id",
    leaveApprovalDetail: "/todo-worklist/leave-approval/:id",
    leaveApprovalPage: "/todo-worklist/leave-approval-page/:id",
    nocApprovalDetail: "/todo-worklist/noc-approval/:id",
    reimbursementApprovalDetail: "/todo-worklist/reimbursement-approval/:id",
    alerts: "/todo-worklist/alerts",
    notifications: "/todo-worklist/notifications",
    officeMails: "/todo-worklist/office-mails",
    tracking: "/todo-worklist/tracking",
    idCardApprovalDetail: "/todo-worklist/id-card-approval/:id",
    medicalAttendanceApproval: "/todo-worklist/medical-attendance-approval/:requestID",
    leaveEncashmentApproval: "/todo-worklist/leave-encashment-approval/:requestID",
    hallBookingApproval: "/todo-worklist/hall-booking-approval/:requestID",
    staffWelfareApproval: "/todo-worklist/staff-welfare/:requestID",
    eAttestationApproval: "/todo-worklist/e-attestation-approval/:requestID",
    itDeclarationApprovalDetail: "/todo-worklist/it-declaration-approval/:id",
    selfTransferApproval: "/todo-worklist/self-transfer-approval/:id",
    transferPostingApproval: "/todo-worklist/transfer-posting-approval/:id",
  },

  // Masters
  masters: {
    wingDesignationDepartment: "/masters/wing-designation-department",
    listNatures: "/masters/find-all-natures",
    natureOfDuty: "/masters/outside-job-nature-of-duty",
    listStays: "/masters/find-all-stays",
    listStatuses: "/masters/find-all-statuses",
    listNocTravel: "/masters/find-all-noc-travel",
    listModesOfCourse: "/masters/find-all-modes-of-course",
    listDocUploadTypes: "/masters/find-all-doc-upload-types",
    listCourseTypes: "/masters/find-all-course-types",
    listCourseCategories: "/masters/find-all-course-categories",
    listCaste: "/masters/find-all-master-caste",
    dnarList: "/masters/dnar-list",
    courseDepartmentList: "/masters/course-department",
  },

  worklist: {
    universalWorklist: "/todo-worklist/tasks",
    clmsAdvanceClaims: "/todo-worklist/clms-advance-claims",
    staffWelfare: "/todo-worklist/staff-welfare",
    itDeclaration: "/todo-worklist/it-declaration",
    loanApproval: "/todo-worklist/loan-approval",
    eAttestation: "/todo-worklist/e-attestation",
    transferPosting: "/todo-worklist/transfer-posting",
    transferPostingApproval: "/todo-worklist/transfer-posting-approval/:id",
    transferRelieving: "/todo-worklist/transfer-relieving",
    approveRequest: "/todo-worklist/approve-request",
    uploadPhoto: "/todo-worklist/upload-photo",
  },

  // NOC Services
  noc: {
    main: "/noc",
    outsideJob: "/noc/outside-job",
    passport: "/noc/passport-visa",
    higherEducation: "/noc/higher-education",
    higherEducationCreate: "/noc/higher-education/create",
    higherEducationEdit: "/noc/higher-education/edit/:id",
    higherEducationDetails: "/noc/higher-education/details/:id",
    foreignVisit: "/noc/ex-india",
    foreignVisitCreate: "/noc/ex-india/create",
    onlineCourse: "/noc/online-course",
    onlineCourseCreate: "/noc/online-course/create",
    onlineCourseDetails: "/noc/online-course/details/:id",
    onlineCourseEdit: "/noc/online-course/edit/:id",
    onlineCourseCreateReimbursement:
      "/noc/online-course/create-reimbursement/:id",
    onlineCourseReimbursementDetails:
      "/noc/online-course/reimbursement-details/:id",
  },

  // idcardManagement
  idCard: {
    list: "/services/id-card",
    createRequest: "/id-card-management/create-request",
    createFamilyMemberRequest: "/services/id-card/inclusion-dependent/create",
    inclusionOfDependent: "/services/id-card/inclusion-dependent",
    deletionOfDependent: "/services/id-card/deletion-dependent",
    familyMemberInclusion: "/services/id-card/family-inclusion",
    adminList: "/admin/id-card-list",
    // New I-Card module pages
    instruction: "/id-card/instruction",
    requestList: "/id-card/requests",
    form: "/id-card/form",
    formEdit: "/id-card/form/edit/:id",
    details: "/id-card/details/:id",
    approval: "/id-card/approval/:id",
  },

  // Leave Management
  LeaveManagement: {
    list: "/leave-management",
    create: "/leave-management/create",
    details: "/leave-management/details/:id",
    calendar: "/leave-management/calendar",
    teamCalendar: "/leave-management/team-calendar",
    timeAccounts: "/leave-management/time-accounts",
    view: "/leave-management/view",
  },

  // E-Requisition (IT)
  eRequisitionIT: {
    list: "/e-requisition-it",
    create: "/e-requisition-it/create",
    details: "/e-requisition-it/details/:id",
  },

  // SAP Authorization
  sapAuthorization: {
    list: "/sap-authorization",
    create: "/sap-authorization/create",
    edit: "/sap-authorization/edit/:id",
    details: "/sap-authorization/details/:id",
    approval: "/sap-authorization/approval/:id",
  },

  // SV4 Card (Smart Validator 4 — Issue/Re-issue)
  sv4Card: {
    list: "/sv4-card",
    create: "/sv4-card/create",
    details: "/sv4-card/details/:referenceNumber",
    approval: "/sv4-card/approve/:requestID",
  },

  // Other Services
  whoIsWho: "/employee-who-is-who",
  salaryStatement: "/services/salary-statement",
  salaryStatementHindi: "/salary-statement-hindi",
  salaryStatementEnglish: "/salary-statement-english",
  multipleSalaryStatement: "/multiple-salary-statement",
  annualPropertyReturn: "/annual-property-return",
  dueDrawn: "/due-drawn",
  policeVerification: "/police-verification",
  displayTaxCard: "/services/display-tax-card",
  taxSimplifier: "/tax-simplifier-statement",
  taxSimplifierDetails: "/tax-simplifier-statement/details",
  taxSimplifierEdit: "/tax-simplifier-statement/edit",
  loanSurety: "/services/loan-surety",
  loanSuretyStatus: "/services/loan-surety/status",
  annualNps: "/services/annual-nps-superannuation",
  annualPf: "/services/annual-pf-details",
  managerSelfService: "/manager-self-service",

  // DMRC Calendar
  dmrcCalendar: "/dmrc-calendar",

  // VPF (Voluntary Provident Fund) Module
  vpfModule: {
    list: "/services/vpf-contribution",
    create: "/services/vpf-contribution/create",
    details: "/services/vpf-contribution/details/:id"
  },

  // Appeal for Contribution
  appealContribution: {
    list: "/services/appeal-contribution",
    create: "/services/appeal-contribution/create",
    details: "/services/appeal-contribution/details/:referenceNumber",
  },

  leaveEncashment: {
    list: "/services/leave-encashment",
    create: "/services/leave-encashment/create",
    review: "/services/leave-encashment/review",
    details: "/services/leave-encashment/details",
  },

  communityHall: {
    list: "/services/community-hall",
    create: "/services/community-hall/create",
    view: "/services/community-hall/view/:referenceNumber",
    overview: "/services/community-hall/all",
  },

  // Prior Approval for IVF, Para 6.2 / 6.3
  medicalAttendance: {
    list: "/services/medical-attendance",
    create: "/services/medical-attendance/create",
    view: "/services/medical-attendance/view/:referenceNumber",
    details: "/services/medical-attendance/details/:referenceNumber",
  },

  // Authority Letter for Annual Comprehensive Health Checkup
  authorityLetterHealthCheckup: {
    list: "/services/authority-letter-health-checkup",
    create: "/services/authority-letter-health-checkup/create",
    view: "/services/authority-letter-health-checkup/view/:referenceNumber",
    details: "/services/authority-letter-health-checkup/details/:referenceNumber",
  },

  staffWelfareFund: {
    list: "/services/staff-welfare-fund",
    create: "/services/staff-welfare-fund/create",
    view: "/services/staff-welfare-fund/view/:id",
  },

  services: {
    list: "/services",
  },

  // for self service routes section
  // for self service routes section
  // identityManagement: "/services/identity-management",
  // reimbursementClaims: "/services/reimbursement",
  // miscHR: "/services/misc-hr",
  // salaryStatement: "/services/salary-statement",
  // staffQuarter: "/services/staff-quarters",
  // welfareGrants: "/services/welfare-grants",
  transferApplications: "/services/transfer-applications",
  transferPosting: {
    hub: "/services/transfer-applications",
    internalVacancy: "/services/transfer-applications/internal-vacancy",
    selfTransfer: "/services/self-transfer",
    mutualTransfer: "/services/transfer-applications/mutual-transfer",
    cancellation: "/services/transfer-applications/transfer-cancellation",
    requestPosting: "/services/transfer-applications/request-for-posting",
    officeOrders: "/services/transfer-applications/office-orders",
  },
  selfTransfer: {
    list: "/services/self-transfer",
    create: "/services/self-transfer/create",
    details: "/services/self-transfer/details/:id",
    approval: "/services/self-transfer/approval/:id",
    approvers: "/services/self-transfer/approvers/:id",
  },
  // medicalLeaveEncashment: "/services/medical-leave-encashment",
  // holidaysMilestones: "/services/holidays-milestones",
  // performanceManagement: "/services/performance-management",
  // taxLoanManagement: "/services/tax-loan-management",
  // healthWelfare: "/services/health-welfare",
  // financialRetirement: "/services/retirement-benefits",

  // Staff Quarter (Employee-facing)
  staffQuarter: {
    overview: "/staff-quarters/overview",
    list: "/staff-quarters",
    newRegistration: "/staff-quarters/new",
    details: "/staff-quarters/details/:id",
    occupation: "/staff-quarters/occupation",
    withdrawal: "/staff-quarters/withdrawal",
    vacationIntimation: "/staff-quarters/vacation-intimation",
    requestVacation: "/staff-quarters/request-vacation",
    vacationIntimationForm: "/staff-quarters/vacation-intimation-form",
    vacationDetails: "/staff-quarters/vacation-intimation/details/:id",
    myAllotments: "/staff-quarters/my-allotments",
    priorityList: "/staff-quarters/priority-list",
    unwillingness: "/staff-quarters/unwillingness",
    mutualExchange: "/staff-quarters/mutual-exchange",
    inventory: {
      dashboard: "/staff-quarters/inventory/dashboard",
      master: "/staff-quarters/inventory/master",
      vacation: "/staff-quarters/inventory/vacation",
      history: "/staff-quarters/inventory/history",
      locations: "/staff-quarters/inventory/locations",
      locationView: "/staff-quarters/inventory/location-view",
    },
    management: {
      overview: "/staff-quarters/manage/overview",
      requests: "/staff-quarters/manage/requests",
      requestDetails: "/staff-quarters/manage/requests/:id",
      houses: "/staff-quarters/manage/houses",
      allotments: "/staff-quarters/manage/allotments",
      priorityList: "/staff-quarters/manage/priority-list",
      reports: "/staff-quarters/manage/reports",
      willingnessInvited: "/staff-quarters/manage/reports/willingness-invited",
      coDashboard: "/staff-quarters/manage/co-dashboard",
      changeApprover: "/staff-quarters/manage/change-approver",
      letterTemplates: "/staff-quarters/manage/letter-templates",
      mutualExchange: "/staff-quarters/manage/mutual-exchange",
    },
  },
  staffQuarterAdmin: {
    dashboard: "/staff-quarters/manage/overview",
    requests: "/staff-quarters/manage/requests",
    requestDetails: "/staff-quarters/manage/requests/:id",
    allotments: "/staff-quarters/manage/allotments",
    priorityList: "/staff-quarters/manage/priority-list",
    coDashboard: "/staff-quarters/manage/co-dashboard",
    houses: "/staff-quarters/manage/houses",
    reports: "/staff-quarters/manage/reports",
    willingnessInvited: "/staff-quarters/manage/reports/willingness-invited",
    vacationDetails: "/staff-quarters/manage/vacation/:id",
    changeApprover: "/staff-quarters/manage/change-approver",
    letterTemplates: "/staff-quarters/manage/letter-templates",
    mutualExchange: "/staff-quarters/manage/mutual-exchange",
  },
  PostPromotion: {
    overview: "/post-promotional/overview",
    list: "/post-promotional",
    newRegistration: "/post-promotional/new",
    details: "/post-promotional/details/:id",
    occupation: "/post-promotional/occupation",
    withdrawal: "/post-promotional/withdrawal",
    vacationIntimation: "/post-promotional/vacation-intimation",
    OfficeOrders: "/post-promotional/office-orders",
    sapSyncLog: "/post-promotional/sap-sync-log",
    PromotionList: "/post-promotional/promotion-list",
    DpcReview: "/post-promotional/dpc-review",
    DpcApprovalList: "/post-promotional/dpc-approval-list",
    ProbationConfirmation: "/post-promotional/probation-confirmation",
  },
  darCase: {
    overview: "/dar-cases/overview",
    new: "/dar-cases/new",
    contemplated: "/dar-cases/contemplated",
    pending: "/dar-cases/pending",
    pendingForm: "/dar-cases/pending-form",
    pendingDetails: "/dar-cases/pending-details/:caseno",
    closed: "/dar-cases/closed",
    closedForm: "/dar-cases/closed-form",
    closedDetails: "/dar-cases/closed-details/:caseno",
    details: "/dar-cases/details/:caseno",
    appealAgainstPenalty: "/dar-cases/appeal-against-penalty",
    appealForm: "/dar-cases/appeal-form",
    appealDetails: "/dar-cases/appeal-details/:caseno",
    sdSuspension: "/dar-cases/sd-suspension",
    sdSuspensionForm: "/dar-cases/sd-suspension-form",
    sdSuspensionDetails: "/dar-cases/sd-suspension-details/:caseno",
    roleManagement: "/dar-cases/role-management",
  },
  Esepration: {
    hub: "/e-sepration",
    switchUser: "/e-sepration/switch-user",
    overview: "/e-sepration/overview",
    intimationResignation: "/e-sepration/intimation-resignation",
    shortNotice: "/e-sepration/short-notice",
    withdrawal: "/e-sepration/withdrawal",
    bondWaiver: "/e-sepration/bond-waiver",
    noDues: "/e-sepration/no-dues",
    finalDetails: "/e-sepration/final-details",
    profile: "/e-sepration/profile",
    approvals: "/e-sepration/approvals",
    approvalDetail: "/e-sepration/approvals/:id",
    hrVerification: "/e-sepration/hr-verification",
    hrVerificationDetail: "/e-sepration/hr-verification/:id",
    hrInitiateCase: "/e-sepration/hr-initiate",
    hrInitiatedCases: "/e-sepration/hr-initiated-cases",
    noDuesInitiate: "/e-sepration/no-dues/initiate",
    noDuesCaseInitiate: "/e-sepration/no-dues-case",
    noDuesCaseDetail: "/e-sepration/no-dues-case/:id",
    noDuesHrReview: "/e-sepration/no-dues/hr-review",
    noDuesHrReviewDetail: "/e-sepration/no-dues/hr-review/:id",
    noDuesNodal: "/e-sepration/no-dues/nodal",
    noDuesVigilance: "/e-sepration/no-dues/vigilance",
    noDuesFinance: "/e-sepration/no-dues/finance",
    // e-separation v2 No-Dues (HR-dispatched, configurable departments)
    noDuesForm: "/e-sepration/no-dues/form",
    noDuesDispatch: "/e-sepration/no-dues/dispatch",
    noDuesDeptClearance: "/e-sepration/no-dues/dept-clearance",
    noDuesDeptAction: "/e-sepration/no-dues/dept-action",
    noDuesDeptActionDetail: "/e-sepration/no-dues/dept-action/:id",
    noDuesApproverReview: "/e-sepration/no-dues/approver-review",
    noDuesApproverReviewDetail: "/e-sepration/no-dues/approver-review/:id",
    noDuesDeptConfig: "/e-sepration/no-dues/departments",
    bondTypeConfig: "/e-sepration/bond-types",
    vigilanceConfig: "/e-sepration/vigilance-config",
    // Consolidated recovery settlement (special settlement department)
    noDuesSettlementInbox: "/e-sepration/no-dues/settlement",
    noDuesSettlementAction: "/e-sepration/no-dues/settlement/action",
    noDuesSettlementActionDetail: "/e-sepration/no-dues/settlement/action/:id",
    noDuesFormView: "/e-sepration/no-dues/form-view/:id",
    // legacy keys (kept for backward compatibility)
    sNoticeRequest: "/e-sepration/short-notice-request",
    withdrawalBondWaiver: "/e-sepration/withdrawal-bond-waiver",
    nodalOfficerDashboard: "/e-sepration/nodal-officer-dashboard",
    hRDashboard: "/e-sepration/hr-dashboard",
    approverDashboard: "/e-sepration/approver-dashboard",
  },
  birthdayAnniversaries: "/birthday-anniversaries",
  publicHolidays: "/public-holidays",
  dataSync: "/administration/data-sync",
  probation: {
    dashboard: "/probation/dashboard",
    newCycle: "/probation/new-cycle",
    cyclesDashboard: "/probation/cycles-dashboard",
    committeeReview: "/probation/committee-review",
    approvalList: "/probation/approval-list",
    officeOrders: "/probation/office-orders",
  },
  apar: {
    dashboard: "/apar",
    download: "/apar/download",
    teamStatus: "/apar/team-status",
    details: "/apar/details/:id",
    channel: "/apar/channel/:id",
    documents: "/apar/documents",
    documentDetails: "/apar/documents/details/:id",
  }
};
